import { Construtor } from './construtor';

export class Indicador implements Construtor<Indicador> {

  public idIndicador: number;
  public nomeIndicador: string;
  public idCliente: number;
  public metaIndicador: number;
  public notaMaximaIndicador: number;
  public quantidadeSetores: number;
  public quantidadeProcessos: number;
  public quantidadeChecklists: number;
  public selecionado: boolean;
  public alterado: boolean;

  constructor(object?: any) {
    if (object !== undefined) {
      if (object instanceof (Indicador)) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }
  }

  set IdIndicador(idIndicador: any) {
    this.idIndicador = idIndicador;
  }

  set NomeIndicador(nomeIndicador: any) {
    this.nomeIndicador = nomeIndicador;
  }

  set IdCliente(idCliente: any) {
    this.idCliente = idCliente;
  }

  set MetaIndicador(metaIndicador: any) {
    this.metaIndicador = metaIndicador;
  }

  parseFromJson(indicadorRotina: any): void {
    this.idIndicador = indicadorRotina.idIndicador;
    this.idCliente = indicadorRotina.idCliente;
    this.metaIndicador = indicadorRotina.metaIndicador;
    this.notaMaximaIndicador = indicadorRotina.notaMaximaIndicador;
    this.nomeIndicador = indicadorRotina.nomeIndicador;
    this.quantidadeChecklists = indicadorRotina.quantidadeChecklists;
    this.quantidadeProcessos = indicadorRotina.quantidadeProcessos;
    this.quantidadeSetores = indicadorRotina.quantidadeSetores;
  }

  copyObject(indicadorRotina: Indicador): void {
    this.idIndicador = indicadorRotina.idIndicador;
    this.idCliente = indicadorRotina.idCliente;
    this.metaIndicador = indicadorRotina.metaIndicador;
    this.notaMaximaIndicador = indicadorRotina.notaMaximaIndicador;
    this.nomeIndicador = indicadorRotina.nomeIndicador;
    this.quantidadeChecklists = indicadorRotina.quantidadeChecklists;
    this.quantidadeProcessos = indicadorRotina.quantidadeProcessos;
    this.quantidadeSetores = indicadorRotina.quantidadeSetores;
  }

  modeloCompleto(): boolean {
    return this.idCliente !== undefined && this.nomeIndicador !== undefined;
  }

  getNewInstance(object?: any): Indicador {
    return new Indicador(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/indicador.ts